import {
  applyMiddleware,
  createStore,
  compose,
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import { createReduxEnhancer } from '@dynamicore/corewatch';

import { ENABLE_REDUX_LOGGER } from 'settings';

import rootReducer from './reducers';

const loggerMiddleware = createLogger();

export function configureStore(preloadedState = {}) {
  const middlewares = [thunkMiddleware];

  if (ENABLE_REDUX_LOGGER) {
    middlewares.push(loggerMiddleware);
  }

  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares),
  );

  const enhancers = [
    middlewareEnhancer,
    // Action types as breadcrumbs only: full state/payloads are too large to send.
    createReduxEnhancer({
      attachState: false,
      actionTransformer: () => undefined,
    }),
  ];
  const composedEnhancers = compose(...enhancers);

  const store = createStore(
    rootReducer,
    preloadedState,
    composedEnhancers,
  );

  return store;
}
